import { post, put, del } from './requests'

const resourcePath = 'document_attachments'

export function createAttachment (attachment) {
  return post(resourcePath, { documentAttachment: { ...attachment } })
}

export function deleteAttachment (id) {
  return del(`${resourcePath}/${id}`)
}

export function updateAttachment (attachment) {
  return put(`${resourcePath}/${attachment.id}`, { documentAttachment: { ...attachment } })
}
